import * as React from "react";

export function useMediaQuery(query: string): boolean {
  const getMatches = React.useCallback(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  }, [query]);

  // Explicit lazy init — avoid passing the callback itself as useState's initializer ambiguity.
  const [matches, setMatches] = React.useState(() => getMatches());

  React.useEffect(() => {
    const media = window.matchMedia(query);
    const listener = () => setMatches(media.matches);
    listener();
    media.addEventListener("change", listener);
    return () => media.removeEventListener("change", listener);
  }, [query]);

  return matches;
}

